export default [
  {
    name: 'settings-emails',
    path: '/settings/emails',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'E-mail',
      icon: 'dvr',
      label: 'E-mail',
      roles: ['Admin']
    }
  },
  {
    name: 'settings-email-new',
    path: '/settings/emails/create',
    component: () => import(/* webpackChunkName: "event" */ './FormCreate.vue'),
    meta: {
      showNavbar: false,
      title: 'E-mail - Novo Template',
      icon: 'dvr',
      label: 'E-mail - Novo Template',
      roles: ['Admin']
    }
  },
  {
    name: 'settings-email-edit',
    path: '/settings/emails/:id/show',
    component: () => import(/* webpackChunkName: "event" */ './FormCreate.vue'),
    meta: {
      showNavbar: false,
      title: 'E-mail - Edição',
      icon: 'dvr',
      label: 'E-mail - Edição',
      roles: ['Admin']
    }
  }
]
